import './App.css';
import 'aos/dist/aos.css';
import AOS from 'aos';
import Certificates from './Certificates';
import CodingProfiles from './CodingProfiles';
import Contact from './Contact';
import ExperienceEducation from './ExperienceEducation';
import Hobbies from './Hobbies';
import Introduction from './Introduction';
import Projects from './Projects';
import Navigation from './Navigation';
import Skills from './Skills';

function App() {
  AOS.init();
  return (
    <div>
      <Navigation/>
      <Introduction />
      <Skills/>
      <ExperienceEducation/>
      <Projects/>
      <Certificates/>
       <Hobbies/>
      <CodingProfiles/>
     <Contact/>
    </div>
  );
}

export default App;
